import React, { Fragment, useState } from 'react';
import { Row, Col, Container, Card, Button } from 'react-bootstrap';
import { Navigate, Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle, faCheckCircle } from '@fortawesome/free-solid-svg-icons'
import '../../../styles/diario.scss';


function HomeLoggedSolicScreen() {
    const [pendentes, setPendentes] = useState(false)
    const [respondidas, setRespondidas] = useState(false)


    if (respondidas) {
        return <Navigate to={{ pathname: '/ti/solicitacao/respondidas' }} />
    }
    if (pendentes) {
        return <Navigate to={{ pathname: '/ti/solicitacao/pendentes' }} />
    }

    return (
        <Fragment>
            <Container>
                <Row xs={1} lg={2}>
                    <Col>
                        <Card className='card-list' onClick={e => setPendentes(true)}>
                            <Card.Body>
                                <Row xs={1}>
                                    <Col>
                                        <Row xs={2}>
                                            <Col xs={2}>
                                                <FontAwesomeIcon className='icon-cad' icon={faExclamationCircle} />
                                            </Col>
                                            <Col xs={10}>
                                                <p className='titulo-lei'>Solicitações Pendentes</p>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col>
                        <Card className='card-list' onClick={e => setRespondidas(true)}>
                            <Card.Body>
                                <Row xs={1}>
                                    <Col>
                                        <Row xs={2}>
                                            <Col xs={2}>
                                                <FontAwesomeIcon className='icon-cad' icon={faCheckCircle} />
                                            </Col>
                                            <Col xs={10}>
                                                <p className='titulo-lei'>Solicitações Respondidas</p>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
                    <Fragment>
                        <br /><br />
                        <Link to={'/ti'}>
                            <Button variant="danger" type="button">
                                Voltar
                            </Button>
                        </Link>
                    </Fragment>
            </Container>
        </Fragment>
    );
}

export default HomeLoggedSolicScreen;